module.exports = __webpack_public_path__ + "img/banner1.da1a1407.png";